import { Component, OnInit, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export interface MenuItem {
  label: string;
  action: Function;
}

@Component({
    selector: 'app-dropdown-menu',
    templateUrl: './dropdown-menu.component.html',
    styleUrls: ['./dropdown-menu.component.scss'],
    providers: [TranslatePipe],
    standalone: false
})
export class DropdownMenuComponent {
  @Input() menuItems: MenuItem[];

  itemClick(menuItem: MenuItem) {
    menuItem.action();
  }
}
